import {Component, OnInit, Output, EventEmitter, Input} from '@angular/core';
import {OperatoryDataModel} from '../../../models/clients/operatory-data.model';
import {SchedulingService} from '../../../modules/scheduling/scheduling.service';
import {LocalStorageService} from '../../../services/local-storage.service';
import {TdoUserLocationConfigurationModel} from '../../../models/configuration/user/tdo-user-location-configuration.model';
import {OfficeLocationsService} from '../../../modules/configuration/office-locations/office-locations.service';
import {Globals} from '../../../globals';
import {ClientLocationDataModel} from '../../../models/clients/client-location-data.model';
import {TdoDropdownChange} from '../../../tdo-controls/common/tdo-dropdown-v2/models/tdo-dropdown-change';
import {LocationsSelectionModel} from '../models/locations-selection.model';

@Component({
  standalone: false,
  selector: 'app-scheduler-operatory-selector',
  templateUrl: './scheduler-operatory-selector.component.html',
  styleUrls: ['./scheduler-operatory-selector.component.scss']
})
export class SchedulerOperatorySelectorComponent implements OnInit {
  // Todo: operatoryDataModels is an issue if the site is refreshed or loaded directly into the scheduler.
  // Its data wouldn't have been loaded outside.
  @Input() operatoryDataModels: OperatoryDataModel[] = [];

  @Output() operatoriesSelected = new EventEmitter<OperatoryDataModel[]>();
  @Output() locationsSelected = new EventEmitter<ClientLocationDataModel[]>();
  @Output() locationsOpsChanged = new EventEmitter<LocationsSelectionModel>();

  selectedOperatoriesIds: string[] = [];
  locations: ClientLocationDataModel[] = [];
  selectedLocations: ClientLocationDataModel[] = [];
  selectedOperatories: OperatoryDataModel[] = [];

  constructor(private localStorageService: LocalStorageService,
              private globals: Globals,
              private schedulingService: SchedulingService,
              private officeLocationService: OfficeLocationsService) { }

  ngOnInit(): void {
    this.officeLocationService.getAllLocations().subscribe((locationsRes) => {
      this.locations = locationsRes;
      // this.selectedLocation = this.locations.find(p => p.LOCID.toString() === this.globals.LOCID);

      const storedLocationIds = JSON.parse(localStorage.getItem('schedule-location-ids')) as number[];
      let storedLocations: ClientLocationDataModel[];
      if (storedLocationIds && storedLocationIds.length > 0) {
        storedLocations = this.locations.filter(p => storedLocationIds.includes(p.LOCID));
      }
      if (storedLocations && storedLocations.length > 0) {
        this.selectedLocations = this.locations.filter(p => storedLocations.includes(p));
      } else {
        const loc = this.locations.find(p => p.LOCID.toString() === this.globals.LOCID);
        if (loc) {
          this.selectedLocations = [loc];
        }
      }
    });
  }

  loadOperatorySelectionsFromLocalStorage() {
    const storedOps = localStorage.getItem('Schedule-Ops');
    if (storedOps) {
      this.selectedOperatoriesIds = JSON.parse(storedOps);

      if (this.selectedOperatoriesIds.length === 0) {
        const ops = this.operatoryDataModels.map(p => p.OperatoryId);
        this.saveOperatorySelectionsToLocalStorage(ops);
      }
    } else {
      const ops = this.operatoryDataModels.map(p => p.OperatoryId);
      this.selectedOperatoriesIds = ops;
      this.saveOperatorySelectionsToLocalStorage(ops);
    }

    this.selectedOperatories = this.operatoryDataModels.filter(p => this.selectedOperatoriesIds.includes(p.OperatoryId));
    // this.operatoriesSelected.emit(this.selectedOperatories);
  }

  saveOperatorySelectionsToLocalStorage(operatoryIds: string[]) {
    //
    localStorage.setItem('Schedule-Ops', JSON.stringify(operatoryIds));
    // this.operatoriesSelected.emit(operatoryIds);
  }

  isModelSelected(model: OperatoryDataModel) {
    const id = this.selectedOperatoriesIds.find(p => p === model.OperatoryId);
    return id !== undefined;
  }

  onOperatoryPillClick(model: OperatoryDataModel) {
    let id = this.selectedOperatoriesIds.findIndex(p => p === model.OperatoryId);
    if (id > -1) {
      this.selectedOperatoriesIds.splice(id, 1);
    } else {
      this.selectedOperatoriesIds.push(model.OperatoryId);
    }

    this.selectedOperatories = this.operatoryDataModels.filter(p => this.selectedOperatoriesIds.includes(p.OperatoryId));
    this.operatoriesSelected.emit(this.selectedOperatories);
    this.saveOperatorySelectionsToLocalStorage(this.selectedOperatoriesIds);
  }

  onLocationSelectionChange(event: TdoDropdownChange) {

    this.selectedLocations = event.value as ClientLocationDataModel[];
    const locations = event.value as ClientLocationDataModel[];

    const locids = this.selectedLocations.map(p => p.LOCID);
    localStorage.setItem('schedule-location-ids', JSON.stringify(locids));
    this.schedulingService.getOperatoriesV2(locids).subscribe((res) => {
      this.operatoryDataModels = res;
      this.loadOperatorySelectionsFromLocalStorage();

      // Check if atleast one op per location is selected
      for (const id of locids) {
        let opsForLocation = this.operatoryDataModels.filter(p => p.LOCID === id);
        opsForLocation = opsForLocation.sort((a, b) => {
          return a.OperatoryOrder - b.OperatoryOrder;
        });
        const opsForLocationIds = opsForLocation.map(p => p.OperatoryId);
        let isExists = false;
        for (const opp of opsForLocationIds) {
          if (this.selectedOperatories.map(p => p.OperatoryId).includes(opp)) {
            isExists = true;
          }
        }
        if (!isExists) {
          console.log('Adding default op for location: ', opsForLocation[0]);
          this.selectedOperatories.push(opsForLocation[0]);
          this.selectedOperatoriesIds = this.selectedOperatories.map(p => p.OperatoryId);
          localStorage.setItem('Schedule-Ops', JSON.stringify(this.selectedOperatoriesIds));
        }
      }

      const mod = new LocationsSelectionModel();
      mod.locations = this.selectedLocations;
      mod.operatories = this.selectedOperatories;
      this.locationsOpsChanged.emit(mod);
    });

    this.locationsSelected.emit(locations);
  }

  getLocationShortName(model: OperatoryDataModel) {
    const loc = this.selectedLocations.find(p => p.LOCID === model.LOCID);
    if (loc) {
      return loc.LocationShortName;
    }
  }
}
